import { Component, Input } from '@angular/core';
import { AcademicYearSupplements } from '../../models';
import { NgIf } from '@angular/common';
import { AyaSupplementItemsComponent } from './aya-supplement-items/aya-supplement-items.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-supplements',
  imports: [NgIf, AyaSupplementItemsComponent],
  templateUrl: './aya-supplements.component.html',
  styleUrls: ['./aya-supplements.component.scss', './print-aya-supplements.component.scss'],
})
export class AyaSupplementsComponent {
  @Input() supplements: AcademicYearSupplements;
}
